<template>
	<Teleport to="body">
		<transition name="fade">
			<div
				v-if="isNudgeVisible"
				class="
					absolute top-[72px] right-4 flex max-w-[561px] justify-between
					gap-2.5 rounded-xl border border-won-green bg-white px-3 py-3.5
				"
			>
				<div class="flex items-start gap-2.5">
					<div>
						<WonsultingAiLight />
					</div>
					<ActivityMessage
						:message="eventObject?.message"
						:action-text="eventObject?.action_text"
						:action-link="eventObject?.link"
						:created-at="eventObject?.created_at"
						:show-time="false"
					/>
				</div>

				<button
					class="self-start"
					@click="hideNudge"
				>
					<XMarkIcon class="size-[18px]" />
				</button>
			</div>
		</transition>
	</Teleport>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';

import { XMarkIcon } from '@heroicons/vue/20/solid';
import WonsultingAiLight from '../../icons/wonsultingai-light.vue';
import { setAuthState } from '../../composables/auth.js';
import ActivityMessage from './components/activity-message.vue';

import { useActivityStore } from '../../store/activity.store.js';

const activityStore = useActivityStore();

const { isNudgeVisible } = storeToRefs(activityStore);
const { showNudge, hideNudge, fetchNotifications } = activityStore;

const { getUser, isAuthenticated } = setAuthState();

const eventObject = ref({});

onMounted(() => {
	if (!isAuthenticated()) {return;}

	window.Echo.private(`users-nudges.${getUser().id}`).listen('NudgeCreatedEvent', async (event) => {
		await fetchNotifications();
		showNudge();
        
		eventObject.value = event.nudge;

		setTimeout(() => {
			hideNudge();
		}, 5000);
	});
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
